import {
  Button,
  Card,
  Checkbox,
  Form,
  Grid,
  Row,
  Space,
  Spinner
} from "@masterteam/mt-design-react";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { array, boolean, number, object, string } from "yup";
import { addToast } from "../../../helpers";
import { downloadFile } from "../../../helpers/attachments";
import useIsAr from "../../../Hooks/useIsAr";
import api from "../../../providers/api";

import moment from "moment";
import "./style.scss";
const { Col } = Grid;

const filterSchema = object().shape({
  Strategies: array().of(string()),
  Themes: array().of(string()),
  Objectives: array().of(string()),
  Year: number(),
  Quarter: number()
});

const validationSchema = object().shape({
  GeneralPerformance: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  }),
  StrategicObjectiveCards: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  }),
  KPIJustificationAndCorrectiveActions: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  }),
  ProjectJustificationAndCorrectiveActions: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  }),
  KPIChangeRequests: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  }),
  ProjectChangeRequests: object().shape({
    IsSelected: boolean(),
    Filter: filterSchema
  })
});

const { Field } = Form;

const StrategyReportFilters = ({}) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [isWordLoading, setIsWordLoading] = useState(false);
  const [strategies, setStrategies] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [checkBoxes, setCheckBoxes] = useState(["GeneralPerformance"]);
  const [years, setYears] = useState([]);
  const [defaultQuarter, setDefaultQuarter] = useState(null);
  const [generalQuarter, setGeneralQuarter] = useState(null);
  const [defaultYear, setDefaultYear] = useState(null);
  const [generalYear, setGeneralYear] = useState(null);
  const [generalThemes, setGeneralThemes] = useState([]);
  const [generalObjectives, setGeneralObjectives] = useState([]);
  const [strategicObjectiveCardsThemes, setStrategicObjectiveCardsThemes] =
    useState([]);
  const [
    strategicObjectiveCardsObjectives,
    setStrategicObjectiveCardsObjectives
  ] = useState([]);
  const [
    kPIJustificationAndCorrectiveActionsThemes,
    setKPIJustificationAndCorrectiveActionsThemes
  ] = useState([]);
  const [
    kPIJustificationAndCorrectiveActionsObjectives,
    setKPIJustificationAndCorrectiveActionsObjectives
  ] = useState([]);
  const [
    projectJustificationAndCorrectiveActionsThemes,
    setProjectJustificationAndCorrectiveActionsThemes
  ] = useState([]);
  const [
    projectJustificationAndCorrectiveActionsObjectives,
    setProjectJustificationAndCorrectiveActionsObjectives
  ] = useState([]);
  const [kPIChangeRequestsThemes, setKPIChangeRequestsThemes] = useState([]);
  const [kPIChangeRequestsObjectives, setKPIChangeRequestsObjectives] =
    useState([]);
  const [projectChangeRequestsThemes, setProjectChangeRequestsThemes] =
    useState([]);
  const [projectChangeRequestsObjectives, setProjectChangeRequestsObjectives] =
    useState([]);
  const quarters = useSelector(({ theme }) => theme.Quarters.item.Items);

  const [currentGeneralThemes, setCurrentGeneralThemes] = useState([]);
  const [currentSelectedStrategies, setcurrentSelectedStrategies] = useState(
    []
  );

  const initialValues = {
    GeneralPerformance: {
      IsSelected: true,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: years?.find((item) => +item?.Value === defaultYear),
        Quarter: quarters?.find((item) => +item?.Value === defaultQuarter)
      }
    },
    StrategicObjectiveCards: {
      IsSelected: false,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: null,
        Quarter: null
      }
    },
    KPIJustificationAndCorrectiveActions: {
      IsSelected: false,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: null,
        Quarter: null
      }
    },
    ProjectJustificationAndCorrectiveActions: {
      IsSelected: false,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: null,
        Quarter: null
      }
    },
    KPIChangeRequests: {
      IsSelected: false,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: null,
        Quarter: null
      }
    },
    ProjectChangeRequests: {
      IsSelected: false,
      Filter: {
        Strategies: [],
        Themes: [],
        Objectives: [],
        Year: null,
        Quarter: null
      }
    }
  };
  const getData = async () => {
    setDataLoading(true);
    try {
      const [strategiesRes, yearsRes, filterDateRes] = await Promise.all([
        api.strategy.getAllWithObjectives({ strategyType: 1 }),
        api.dashboard.getValidYears(),
        api.dashboard.getFilterDate()
      ]);
      setStrategies(strategiesRes.Data ?? []);
      setYears(
        yearsRes.Data?.map((e) => {
          return { Label: e, Value: e };
        })
      );
      setDefaultQuarter(filterDateRes?.Data?.Quarter);
      setDefaultYear(filterDateRes?.Data?.Year);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setDataLoading(false);
    }
  };
  function transformFilter(filter, isSelected) {
    return {
      ...filter,
      Year: !isSelected ? null : filter.Year ? +filter?.Year?.Value : null,
      Quarter: !isSelected
        ? null
        : filter.Quarter
        ? +filter?.Quarter?.Value
        : null
    };
  }
  const onSubmit = async (values, isPdf) => {
    if (isPdf) setIsPDFLoading(true);
    else setIsWordLoading(true);
    const transformedData = {};
    for (const section in values) {
      transformedData[section] = {
        IsSelected: values[section].IsSelected,
        Filter: transformFilter(
          values[section].Filter,
          values[section].IsSelected
        )
      };
    }
    try {
      const body = {
        ...transformedData
      };

      const res = await api.report.getBODReport(body, { isPDF: isPdf });
      const fileUrl = window.URL.createObjectURL(res);
      const dateAndTime = moment().locale("en").format("DD-MM-YYYY hh:mm");

      downloadFile({
        localURL: fileUrl,
        FileName: `Strategic Report - ${dateAndTime}.${isPdf ? "pdf" : "docx"}`
      });
    } catch (error) {
      addToast.error(error?.message, {
        toastId: "get-users-error"
      });
    } finally {
      setIsPDFLoading(false);
      setIsWordLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  function toggleElement(e, element, setFieldValue) {
    if (checkBoxes.includes(element) && checkBoxes?.length <= 1) return;
    const newArr = checkBoxes.includes(element)
      ? checkBoxes.filter((e) => e !== element)
      : [...checkBoxes, element];
    setCheckBoxes(newArr);
    const isSelected = !checkBoxes.includes(element);
    setFieldValue(`${element}.IsSelected`, isSelected);
    if (!isSelected) {
      setFieldValue(`${element}.Filter.Strategies`, []);
      setFieldValue(`${element}.Filter.Themes`, []);
      setFieldValue(`${element}.Filter.Objectives`, []);
    }
    if (isSelected && element !== "GeneralPerformance") {
      setFieldValue(
        `${[element]}.Filter.Strategies`,
        currentSelectedStrategies
      );
      setFieldValue(`${[element]}.Filter.Themes`, []);
      setFieldValue(`${[element]}.Filter.Objectives`, []);
      setFieldValue(
        `${element}.Filter.Year`,
        generalYear
          ? years?.find((item) => +item?.Value === generalYear?.Value)
          : years?.find((item) => +item?.Value === defaultYear)
      );
      setFieldValue(
        `${element}.Filter.Quarter`,
        generalQuarter
          ? quarters?.find((item) => +item?.Value === +generalQuarter?.Value)
          : quarters?.find((item) => +item?.Value === defaultQuarter)
      );
      if (element === "StrategicObjectiveCards") {
        setStrategicObjectiveCardsThemes(currentGeneralThemes);
        setStrategicObjectiveCardsObjectives([]);
      }
      if (element === "KPIJustificationAndCorrectiveActions") {
        setKPIJustificationAndCorrectiveActionsThemes(currentGeneralThemes);
        setKPIJustificationAndCorrectiveActionsObjectives([]);
      }
      if (element === "ProjectJustificationAndCorrectiveActions") {
        setProjectJustificationAndCorrectiveActionsThemes(currentGeneralThemes);
        setProjectJustificationAndCorrectiveActionsObjectives([]);
      }
      if (element === "KPIChangeRequests") {
        setKPIChangeRequestsThemes(currentGeneralThemes);
        setKPIChangeRequestsObjectives([]);
      }
      if (element === "ProjectChangeRequests") {
        setProjectChangeRequestsThemes(currentGeneralThemes);
        setProjectChangeRequestsObjectives([]);
      }
    }
  }

  const shouldShowSection = (id) => checkBoxes.includes(id);

  return dataLoading ? (
    <Row justify="center" align="center" style={{ height: "200px" }}>
      <Spinner size="large" />
    </Row>
  ) : (
    <Card className="filters-container">
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ values, setFieldValue }) => (
          <>
            <Row align="center" justify="end" className="form-actions">
              <Space size="medium">
                <Button
                  loading={isPDFLoading}
                  disabled={isWordLoading || isPDFLoading}
                  type="submit"
                  variant="primary"
                  onClick={() => {
                    onSubmit(values, true);
                  }}
                >
                  {intl.formatMessage({
                    id: "reports.download-pdf"
                  })}
                </Button>

                <Button
                  loading={isWordLoading}
                  disabled={isWordLoading || isPDFLoading}
                  variant="primary"
                  type="submit"
                  onClick={() => {
                    onSubmit(values, false);
                  }}
                >
                  {intl.formatMessage({
                    id: "reports.download-word"
                  })}
                </Button>
              </Space>
            </Row>

            <Space direction="vertical" gap={24} className="form-container">
              <Space direction="vertical" className="filter_header">
                <h3>
                  <FormattedMessage id="reports-main-header" />
                </h3>
                <Row style={{ paddingBottom: 10 }} cols={24}>
                  <Col>
                    <Checkbox
                      id="GeneralPerformance"
                      label={intl.formatMessage({
                        id: "reports-strategy-general-performance"
                      })}
                      onChange={(e) =>
                        toggleElement(e, "GeneralPerformance", setFieldValue)
                      }
                      checked={checkBoxes.includes("GeneralPerformance")}
                    />
                  </Col>

                  <Col>
                    <Checkbox
                      id="StrategicObjectiveCards"
                      label={intl.formatMessage({
                        id: "reports-strategy-cards-target"
                      })}
                      onChange={(e) =>
                        toggleElement(
                          e,
                          "StrategicObjectiveCards",
                          setFieldValue
                        )
                      }
                      checked={checkBoxes.includes("StrategicObjectiveCards")}
                    />
                  </Col>
                  <Col>
                    <Checkbox
                      id="KPIJustificationAndCorrectiveActions"
                      label={intl.formatMessage({
                        id: "reports-strategy-procedures"
                      })}
                      onChange={(e) =>
                        toggleElement(
                          e,
                          "KPIJustificationAndCorrectiveActions",
                          setFieldValue
                        )
                      }
                      checked={checkBoxes.includes(
                        "KPIJustificationAndCorrectiveActions"
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Checkbox
                      id="ProjectJustificationAndCorrectiveActions"
                      label={intl.formatMessage({
                        id: "reports-strategy-late-projects"
                      })}
                      onChange={(e) =>
                        toggleElement(
                          e,
                          "ProjectJustificationAndCorrectiveActions",
                          setFieldValue
                        )
                      }
                      checked={checkBoxes.includes(
                        "ProjectJustificationAndCorrectiveActions"
                      )}
                    />
                  </Col>
                  <Col>
                    <Checkbox
                      id="KPIChangeRequests"
                      label={intl.formatMessage({
                        id: "reports-strategy-kpi-changes"
                      })}
                      onChange={(e) =>
                        toggleElement(e, "KPIChangeRequests", setFieldValue)
                      }
                      checked={checkBoxes.includes("KPIChangeRequests")}
                    />
                  </Col>
                  <Col>
                    <Checkbox
                      id="ProjectChangeRequests"
                      label={intl.formatMessage({
                        id: "reports-strategy-project-changes"
                      })}
                      onChange={(e) =>
                        toggleElement(e, "ProjectChangeRequests", setFieldValue)
                      }
                      checked={checkBoxes.includes("ProjectChangeRequests")}
                    />
                  </Col>
                </Row>
              </Space>
              {shouldShowSection("GeneralPerformance") && (
                <Space size="medium" direction="vertical" id="level-one">
                  <h3>
                    <FormattedMessage id="reports-strategy-general-performance" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={"GeneralPerformance.Filter.Strategies"}
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.GeneralPerformance.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `GeneralPerformance.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setCurrentGeneralThemes(themes);
                          setcurrentSelectedStrategies(selectedStrategyIDs);
                          if (values?.StrategicObjectiveCards?.IsSelected) {
                            setFieldValue(
                              `StrategicObjectiveCards.Filter.Strategies`,
                              selectedStrategyIDs
                            );
                            setStrategicObjectiveCardsThemes(themes);
                            setStrategicObjectiveCardsObjectives([]);
                            setFieldValue(
                              `StrategicObjectiveCards.Filter.Themes`,
                              []
                            );
                            setFieldValue(
                              `StrategicObjectiveCards.Filter.Objectives`,
                              []
                            );
                          }
                          if (
                            values?.KPIJustificationAndCorrectiveActions
                              ?.IsSelected
                          ) {
                            setFieldValue(
                              `KPIJustificationAndCorrectiveActions.Filter.Strategies`,
                              selectedStrategyIDs
                            );
                            setKPIJustificationAndCorrectiveActionsThemes(
                              themes
                            );
                            setKPIJustificationAndCorrectiveActionsObjectives(
                              []
                            );
                            setFieldValue(
                              `KPIJustificationAndCorrectiveActions.Filter.Themes`,
                              []
                            );
                            setFieldValue(
                              `KPIJustificationAndCorrectiveActions.Filter.Objectives`,
                              []
                            );
                          }
                          if (
                            values?.ProjectJustificationAndCorrectiveActions
                              ?.IsSelected
                          ) {
                            setFieldValue(
                              `ProjectJustificationAndCorrectiveActions.Filter.Strategies`,
                              selectedStrategyIDs
                            );
                            setProjectJustificationAndCorrectiveActionsThemes(
                              themes
                            );
                            setProjectJustificationAndCorrectiveActionsObjectives(
                              []
                            );
                            setFieldValue(
                              `ProjectJustificationAndCorrectiveActions.Filter.Themes`,
                              []
                            );
                            setFieldValue(
                              `ProjectJustificationAndCorrectiveActions.Filter.Objectives`,
                              []
                            );
                          }
                          if (values?.KPIChangeRequests?.IsSelected) {
                            setFieldValue(
                              `KPIChangeRequests.Filter.Strategies`,
                              selectedStrategyIDs
                            );
                            setKPIChangeRequestsThemes(themes);
                            setKPIChangeRequestsObjectives([]);
                            setFieldValue(
                              `KPIChangeRequests.Filter.Themes`,
                              []
                            );
                            setFieldValue(
                              `KPIChangeRequests.Filter.Objectives`,
                              []
                            );
                          }
                          if (values?.ProjectChangeRequests?.IsSelected) {
                            setFieldValue(
                              `ProjectChangeRequests.Filter.Strategies`,
                              selectedStrategyIDs
                            );
                            setProjectChangeRequestsThemes(themes);
                            setProjectChangeRequestsObjectives([]);
                            setFieldValue(
                              `ProjectChangeRequests.Filter.Themes`,
                              []
                            );
                            setFieldValue(
                              `ProjectChangeRequests.Filter.Objectives`,
                              []
                            );
                          }

                          setGeneralThemes(themes);
                          setGeneralObjectives([]);
                          setFieldValue(`GeneralPerformance.Filter.Themes`, []);
                          setFieldValue(
                            `GeneralPerformance.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"GeneralPerformance.Filter.Themes"}
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: generalThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: generalThemes.filter((theme) =>
                          values.GeneralPerformance.Filter.Themes?.includes(
                            theme.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `GeneralPerformance.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setGeneralObjectives(objectives);
                          setFieldValue(
                            `GeneralPerformance.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"GeneralPerformance.Filter.Objectives"}
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options: generalObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: generalObjectives.filter((objective) =>
                          values.GeneralPerformance.Filter.Objectives?.includes(
                            objective.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `GeneralPerformance.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={"GeneralPerformance.Filter.Year"}
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          isLoading: dataLoading,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(`GeneralPerformance.Filter.Year`, e);
                            setGeneralYear(e);
                            if (values?.StrategicObjectiveCards?.IsSelected) {
                              setFieldValue(
                                `StrategicObjectiveCards.Filter.Year`,
                                e
                              );
                            }
                            if (
                              values?.KPIJustificationAndCorrectiveActions
                                ?.IsSelected
                            ) {
                              setFieldValue(
                                `KPIJustificationAndCorrectiveActions.Filter.Year`,
                                e
                              );
                            }
                            if (
                              values?.ProjectJustificationAndCorrectiveActions
                                ?.IsSelected
                            ) {
                              setFieldValue(
                                `ProjectJustificationAndCorrectiveActions.Filter.Year`,
                                e
                              );
                            }
                            if (values?.KPIChangeRequests?.IsSelected) {
                              setFieldValue(`KPIChangeRequests.Filter.Year`, e);
                            }
                            if (values?.ProjectChangeRequests?.IsSelected) {
                              setFieldValue(
                                `ProjectChangeRequests.Filter.Year`,
                                e
                              );
                            }
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>

                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={"GeneralPerformance.Filter.Quarter"}
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          isLoading: dataLoading,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `GeneralPerformance.Filter.Quarter`,
                              e
                            );
                            setGeneralQuarter(e);
                            if (values?.StrategicObjectiveCards?.IsSelected) {
                              setFieldValue(
                                `StrategicObjectiveCards.Filter.Quarter`,
                                e
                              );
                            }
                            if (
                              values?.KPIJustificationAndCorrectiveActions
                                ?.IsSelected
                            ) {
                              setFieldValue(
                                `KPIJustificationAndCorrectiveActions.Filter.Quarter`,
                                e
                              );
                            }
                            if (
                              values?.ProjectJustificationAndCorrectiveActions
                                ?.IsSelected
                            ) {
                              setFieldValue(
                                `ProjectJustificationAndCorrectiveActions.Filter.Quarter`,
                                e
                              );
                            }
                            if (values?.KPIChangeRequests?.IsSelected) {
                              setFieldValue(
                                `KPIChangeRequests.Filter.Quarter`,
                                e
                              );
                            }
                            if (values?.ProjectChangeRequests?.IsSelected) {
                              setFieldValue(
                                `ProjectChangeRequests.Filter.Quarter`,
                                e
                              );
                            }
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
              {shouldShowSection("StrategicObjectiveCards") && (
                <Space size="medium" direction="vertical" id="level-two">
                  <h3>
                    <FormattedMessage id="reports-strategy-cards-target" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={"StrategicObjectiveCards.Filter.Strategies"}
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.StrategicObjectiveCards.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setStrategicObjectiveCardsThemes(themes);
                          setStrategicObjectiveCardsObjectives([]);
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Themes`,
                            []
                          );
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"StrategicObjectiveCards.Filter.Themes"}
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: strategicObjectiveCardsThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategicObjectiveCardsThemes.filter((theme) =>
                          values.StrategicObjectiveCards.Filter.Themes?.includes(
                            theme.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setStrategicObjectiveCardsObjectives(objectives);
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"StrategicObjectiveCards.Filter.Objectives"}
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options: strategicObjectiveCardsObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategicObjectiveCardsObjectives.filter(
                          (objective) =>
                            values.StrategicObjectiveCards.Filter.Objectives?.includes(
                              objective.ID
                            )
                        ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `StrategicObjectiveCards.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={"StrategicObjectiveCards.Filter.Year"}
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `StrategicObjectiveCards.Filter.Year`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={"StrategicObjectiveCards.Filter.Quarter"}
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `StrategicObjectiveCards.Filter.Quarter`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
              {shouldShowSection("KPIJustificationAndCorrectiveActions") && (
                <Space size="medium" direction="vertical" id="strategy">
                  <h3>
                    <FormattedMessage id="reports-strategy-procedures" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={
                        "KPIJustificationAndCorrectiveActions.Filter.Strategies"
                      }
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.KPIJustificationAndCorrectiveActions.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setKPIJustificationAndCorrectiveActionsThemes(themes);
                          setKPIJustificationAndCorrectiveActionsObjectives([]);
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Themes`,
                            []
                          );
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={
                        "KPIJustificationAndCorrectiveActions.Filter.Themes"
                      }
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: kPIJustificationAndCorrectiveActionsThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value:
                          kPIJustificationAndCorrectiveActionsThemes.filter(
                            (theme) =>
                              values.KPIJustificationAndCorrectiveActions.Filter.Themes?.includes(
                                theme.ID
                              )
                          ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setKPIJustificationAndCorrectiveActionsObjectives(
                            objectives
                          );
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={
                        "KPIJustificationAndCorrectiveActions.Filter.Objectives"
                      }
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options: kPIJustificationAndCorrectiveActionsObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value:
                          kPIJustificationAndCorrectiveActionsObjectives.filter(
                            (objective) =>
                              values.KPIJustificationAndCorrectiveActions.Filter.Objectives?.includes(
                                objective.ID
                              )
                          ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `KPIJustificationAndCorrectiveActions.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={
                          "KPIJustificationAndCorrectiveActions.Filter.Year"
                        }
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `KPIJustificationAndCorrectiveActions.Filter.Year`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={
                          "KPIJustificationAndCorrectiveActions.Filter.Quarter"
                        }
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `KPIJustificationAndCorrectiveActions.Filter.Quarter`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
              {shouldShowSection(
                "ProjectJustificationAndCorrectiveActions"
              ) && (
                <Space size="medium" direction="vertical" id="kpis">
                  <h3>
                    <FormattedMessage id="reports-strategy-late-projects" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={
                        "ProjectJustificationAndCorrectiveActions.Filter.Strategies"
                      }
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.ProjectJustificationAndCorrectiveActions.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setProjectJustificationAndCorrectiveActionsThemes(
                            themes
                          );
                          setProjectJustificationAndCorrectiveActionsObjectives(
                            []
                          );
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Themes`,
                            []
                          );
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={
                        "ProjectJustificationAndCorrectiveActions.Filter.Themes"
                      }
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: projectJustificationAndCorrectiveActionsThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value:
                          projectJustificationAndCorrectiveActionsThemes.filter(
                            (theme) =>
                              values.ProjectJustificationAndCorrectiveActions.Filter.Themes?.includes(
                                theme.ID
                              )
                          ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setProjectChangeRequestsObjectives(objectives);
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={
                        "ProjectJustificationAndCorrectiveActions.Filter.Objectives"
                      }
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options:
                          projectJustificationAndCorrectiveActionsObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value:
                          projectJustificationAndCorrectiveActionsObjectives.filter(
                            (objective) =>
                              values.ProjectJustificationAndCorrectiveActions.Filter.Objectives?.includes(
                                objective.ID
                              )
                          ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `ProjectJustificationAndCorrectiveActions.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={
                          "ProjectJustificationAndCorrectiveActions.Filter.Year"
                        }
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `ProjectJustificationAndCorrectiveActions.Filter.Year`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={
                          "ProjectJustificationAndCorrectiveActions.Filter.Quarter"
                        }
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `ProjectJustificationAndCorrectiveActions.Filter.Quarter`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
              {shouldShowSection("KPIChangeRequests") && (
                <Space size="medium" direction="vertical">
                  <h3>
                    <FormattedMessage id="reports-strategy-kpi-changes" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={"KPIChangeRequests.Filter.Strategies"}
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.KPIChangeRequests.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `KPIChangeRequests.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setKPIChangeRequestsThemes(themes);
                          setKPIChangeRequestsObjectives([]);
                          setFieldValue(`KPIChangeRequests.Filter.Themes`, []);
                          setFieldValue(
                            `KPIChangeRequests.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"KPIChangeRequests.Filter.Themes"}
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: kPIChangeRequestsThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: kPIChangeRequestsThemes.filter((theme) =>
                          values.KPIChangeRequests.Filter.Themes?.includes(
                            theme.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `KPIChangeRequests.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setKPIChangeRequestsObjectives(objectives);
                          setFieldValue(
                            `KPIChangeRequests.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"KPIChangeRequests.Filter.Objectives"}
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options: kPIChangeRequestsObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: kPIChangeRequestsObjectives.filter((objective) =>
                          values.KPIChangeRequests.Filter.Objectives?.includes(
                            objective.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `KPIChangeRequests.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={"KPIChangeRequests.Filter.Year"}
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(`KPIChangeRequests.Filter.Year`, e);
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={"KPIChangeRequests.Filter.Quarter"}
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `KPIChangeRequests.Filter.Quarter`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
              {shouldShowSection("ProjectChangeRequests") && (
                <Space size="medium" direction="vertical">
                  <h3>
                    <FormattedMessage id="reports-strategy-project-changes" />
                  </h3>
                  <Row size="medium">
                    <Field
                      type="select"
                      name={"ProjectChangeRequests.Filter.Strategies"}
                      label={intl.formatMessage({
                        id: "reports-strategy-authority"
                      })}
                      inputProps={{
                        options: strategies,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: strategies.filter((strategy) =>
                          values.ProjectChangeRequests.Filter.Strategies?.includes(
                            strategy.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedStrategyIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Strategies`,
                            selectedStrategyIDs
                          );
                          const themes = e.map((item) => item?.Themes).flat();
                          setProjectChangeRequestsThemes(themes);
                          setProjectChangeRequestsObjectives([]);
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Themes`,
                            []
                          );
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"ProjectChangeRequests.Filter.Themes"}
                      label={intl.formatMessage({ id: "report-strategy-axis" })}
                      inputProps={{
                        options: projectChangeRequestsThemes,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        isLoading: dataLoading,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: projectChangeRequestsThemes.filter((theme) =>
                          values.ProjectChangeRequests.Filter.Themes?.includes(
                            theme.ID
                          )
                        ),
                        onChange: (e) => {
                          const selectedThemesIDs = e?.map((item) => item?.ID);
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Themes`,
                            selectedThemesIDs
                          );
                          const objectives = e
                            .map((item) => item?.Objectives)
                            .flat();
                          setProjectChangeRequestsObjectives(objectives);
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Objectives`,
                            []
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <Field
                      type="select"
                      name={"ProjectChangeRequests.Filter.Objectives"}
                      label={intl.formatMessage({
                        id: "reports-strategy-target"
                      })}
                      inputProps={{
                        options: projectChangeRequestsObjectives,
                        isLoading: dataLoading,
                        getOptionLabel: (el) =>
                          isAr ? el.ArabicName : el.EnglishName,
                        getOptionValue: (el) => el.ID,
                        placeholder: intl.formatMessage({
                          id: "common.select-new"
                        }),
                        isMulti: true,
                        value: projectChangeRequestsObjectives.filter(
                          (objective) =>
                            values.ProjectChangeRequests.Filter.Objectives?.includes(
                              objective.ID
                            )
                        ),
                        onChange: (e) => {
                          const selectedObjectiveIDs = e?.map(
                            (item) => item?.ID
                          );
                          setFieldValue(
                            `ProjectChangeRequests.Filter.Objectives`,
                            selectedObjectiveIDs
                          );
                        }
                      }}
                      hideErrorMessage
                    />
                    <div className="select-half-width-container">
                      <Field
                        type="select"
                        name={"ProjectChangeRequests.Filter.Year"}
                        label={intl.formatMessage({ id: "dashboards.year" })}
                        inputProps={{
                          options: years,
                          getOptionLabel: (el) => el?.Label,
                          getOptionValue: (el) => el?.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.year"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `ProjectChangeRequests.Filter.Year`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                    <div className="quarter-container">
                      <Field
                        type="select"
                        name={"ProjectChangeRequests.Filter.Quarter"}
                        label={intl.formatMessage({ id: "dashboards.quarter" })}
                        inputProps={{
                          options: quarters,
                          getOptionLabel: (el) =>
                            isAr ? el.Arabic : el.English,
                          getOptionValue: (el) => el.Value,
                          placeholder: intl.formatMessage({
                            id: "dashboards.quarter"
                          }),
                          isMulti: false,
                          onChange: (e) => {
                            setFieldValue(
                              `ProjectChangeRequests.Filter.Quarter`,
                              e
                            );
                          }
                        }}
                        hideErrorMessage
                      />
                    </div>
                  </Row>
                </Space>
              )}
            </Space>
          </>
        )}
      </Form>
    </Card>
  );
};

export default StrategyReportFilters;
